import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/global.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initializeAuth } from './utils/auth';
import { initStorage, migrateFromLocalStorage } from './map-editor-shared/lib/utils';

// Initialize authentication and handle migration
initializeAuth();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Initialize IndexedDB storage BEFORE rendering.
// This ensures persisted floor/map data is loaded into memory cache
// before any Zustand stores access it. Without this, returning to the
// editor from the dashboard shows a blank map because the cache is empty.
async function bootstrap() {
  try {
    await initStorage();
    await migrateFromLocalStorage();
  } catch (err) {
    console.error('Failed to initialize storage:', err);
  }

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

bootstrap();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
